var render, staticRenderFns
import script from "./TabList.vue?vue&type=script&lang=js&"
export * from "./TabList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/Ceres Build Stable/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e895e41')) {
      api.createRecord('6e895e41', component.options)
    } else {
      api.reload('6e895e41', component.options)
    }
    
  }
}
component.options.__file = "resources/js/src/app/components/common/TabList.vue"
export default component.exports